module.exports = " <div class=drag><i>&#xe906;</i></div> <div class=checkbox v-if=isFinished> <i @click=handleClick>&#xe901;</i> </div> <div class=checkbox v-else> <i @click=handleClick>&#xe900;</i> </div> <input-box :text=item.todo_content :is-finished=isFinished :item-id=item.item_id @input-box-change=handleInputBoxChange :index=index></input-box> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/todo-item.vue
 ** module id = 54
 ** module chunks = 1
 **/